import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-background-icon',
  templateUrl: './background-icon.component.html',
  styleUrl: './background-icon.component.scss',
  host: {
    '[style.top.%]': 'top',
    '[style.left.%]': 'left',
    '[style.width.px]': 'width',
    '[style.opacity]': 'opacity',
    '[class.background-icon--hidden-mobile]': 'hideOnMobile',
  },
})
export class BackgroundIconComponent {
  @Input() src!: string;
  @Input() top: number;
  @Input() left: number;
  @Input() width: number;
  @Input() opacity = 1;
  @Input() hideOnMobile = false;
}
